export var ScrollingUtils = {
    getYPosOnPage: function (el) {
        return el.getBoundingClientRect().top + window.scrollY;
    },
    isYPosVisible: function (y) {
        return window.scrollY < y && y < window.scrollY + window.innerHeight;
    },
    smoothScrollTo: function (y) {
        window.scrollTo({
            top: y,
            behavior: 'smooth',
        });
    },
};
